import React from 'react'

const RiseUpNoLsScreen = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        verticalAlign: 'middle',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <h1>Rise Up Mode</h1>
      <p>We need to know your learning session to continue in ru mode</p>
      <p>Please contact your administrator to get access to the course.</p>
    </div>
  )
}

export default RiseUpNoLsScreen
